import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderProduct extends React.Component {
    static propTypes = {
        product: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    renderSubProduct(sub_product, key) {
        const { t } = this.props;
        return (
            <Fragment key={key}>
                <tr
                    className="m2g-order-confirmation-item m2g-order-confirmation-product m2g-order-confirmation-product--sub-product"
                    data-product-name={sub_product.menu_product.backend_name}
                    data-tags={sub_product.menu_product.tags.join(' ')}
                >
                    <td className="m2g-order-confirmation-item-thumbnail">
                        {sub_product.menu_product.image_src && (
                            <img
                                alt={sub_product.menu_product.name}
                                className="m2g-order-confirmation-product-image m2g-image"
                                src={sub_product.menu_product.image_src}
                            />
                        )}
                    </td>

                    <td className="m2g-order-confirmation-item-content">
                        <span
                            className={`m2g-order-confirmation-product-quantity ${
                                sub_product.quantity > 1 ? '' : 'm2g-hidden'
                            }`}
                        >
                            {sub_product.quantity}
                        </span>

                        <span
                            className={`m2g-times m2g-text--offset m2g-text--small  ${
                                sub_product.quantity > 1 ? '' : 'm2g-hidden'
                            }`}
                        >
                            &nbsp;&times;&nbsp;
                        </span>

                        <span className="m2g-order-confirmation-product-name">
                            {sub_product.menu_product.name}
                        </span>

                        <span className="m2g-order-confirmation-product-size">
                            {sub_product.size ? ` (${sub_product.size})` : ''}
                        </span>

                        <span className="m2g-order-confirmation-product-sub-product-total-added">
                            <span className="m2g-order-confirmation-product-sub-product-price-plus-symbol">
                                +
                            </span>
                            {t('common:price', {
                                price: sub_product.list_total,
                            })}
                        </span>

                        {!!(
                            sub_product.display_modifiers.added.length ||
                            sub_product.display_modifiers.removed.length
                        ) && (
                            <div className="m2g-order-confirmation-product-modifiers">
                                <span
                                    className={`m2g-text--offset m2g-text--small m2g-order-confirmation-product-added-modifiers m2g-text--offset ${
                                        !sub_product.display_modifiers.added
                                            .length
                                            ? 'm2g-hidden'
                                            : ''
                                    }`}
                                >
                                    {sub_product.display_modifiers.added.map(
                                        (modifier, index) => {
                                            return [
                                                index === 0 ? ' ' : ', ',
                                                <span
                                                    key={modifier.id}
                                                    className="m2g-order-confirmation-modifier m2g-order-confirmation-modifier--added"
                                                >
                                                    {modifier.toString()}
                                                </span>,
                                            ];
                                        }
                                    )}
                                </span>
                                <span
                                    className={`m2g-text--offset m2g-text--comment m2g-text--small m2g-order-confirmation-product-removed-modifiers m2g-text--offset ${
                                        !sub_product.display_modifiers.removed
                                            .length
                                            ? 'm2g-hidden'
                                            : ''
                                    }`}
                                >
                                    {sub_product.display_modifiers.removed.map(
                                        (modifier, index) => {
                                            return [
                                                index === 0 ? ' ' : ', ',
                                                <span
                                                    key={modifier.id}
                                                    className="m2g-text--removed m2g-order-confirmation-modifier m2g-order-confirmation-modifier--removed"
                                                >
                                                    {modifier.toString()}
                                                </span>,
                                            ];
                                        }
                                    )}
                                </span>
                            </div>
                        )}

                        {sub_product.comment && (
                            <div className="m2g-order-confirmation-product-comment m2g-text--offset m2g-text--small">
                                {_.escape(sub_product.comment)}
                            </div>
                        )}
                    </td>

                    <td className="m2g-order-confirmation-item-total m2g-order-confirmation-product-total">
                        <span className="m2g-order-confirmation-product-total-content m2g-hidden">
                            {t('common:price', {
                                price: sub_product.list_total,
                            })}
                        </span>
                    </td>
                </tr>
                {sub_product
                    .getSubProducts()
                    .map(sub_sub_product =>
                        this.renderSubProduct(
                            sub_sub_product,
                            sub_sub_product.cid
                        )
                    )}
            </Fragment>
        );
    }

    render() {
        const { product, t } = this.props;
        const sub_products = product.getSubProducts();
        return (
            <>
                <tr
                    className="m2g-order-confirmation-item m2g-order-confirmation-product"
                    data-product-name={product.menu_product.backend_name}
                    data-tags={product.menu_product.tags.join(' ')}
                >
                    <td className="m2g-order-confirmation-item-thumbnail">
                        {product.menu_product.image_src && (
                            <img
                                alt={product.menu_product.name}
                                className="m2g-order-confirmation-product-image m2g-image"
                                src={product.menu_product.image_src}
                            />
                        )}
                    </td>

                    <td className="m2g-order-confirmation-item-content">
                        <span className="m2g-order-confirmation-product-quantity">
                            {product.quantity}
                        </span>

                        <span className="m2g-times m2g-text--offset m2g-text--small">
                            &nbsp;&times;&nbsp;
                        </span>

                        <span className="m2g-order-confirmation-product-name">
                            {product.menu_product.name}
                        </span>

                        <span className="m2g-order-confirmation-product-size">
                            {product.size ? ` (${product.size})` : ''}
                        </span>

                        {!!(
                            product.display_modifiers.added.length ||
                            product.display_modifiers.removed.length
                        ) && (
                            <div className="m2g-order-confirmation-product-modifiers">
                                <span
                                    className={`m2g-text--offset m2g-text--small m2g-order-confirmation-product-added-modifiers m2g-text--offset ${
                                        !product.display_modifiers.added.length
                                            ? 'm2g-hidden'
                                            : ''
                                    }`}
                                >
                                    {product.display_modifiers.added.map(
                                        (modifier, index) => {
                                            return [
                                                index === 0 ? ' ' : ', ',
                                                <span
                                                    key={modifier.id}
                                                    className="m2g-order-confirmation-modifier m2g-order-confirmation-modifier--added"
                                                >
                                                    {modifier.toString()}
                                                </span>,
                                            ];
                                        }
                                    )}
                                </span>
                                <span
                                    className={`m2g-text--offset m2g-text--comment m2g-text--small m2g-order-confirmation-product-removed-modifiers m2g-text--offset ${
                                        !product.display_modifiers.removed
                                            .length
                                            ? 'm2g-hidden'
                                            : ''
                                    }`}
                                >
                                    {product.display_modifiers.removed.map(
                                        (modifier, index) => {
                                            return [
                                                index === 0 ? ' ' : ', ',
                                                <span
                                                    key={modifier.id}
                                                    className="m2g-text--removed m2g-order-confirmation-modifier m2g-order-confirmation-modifier--removed"
                                                >
                                                    {modifier.toString()}
                                                </span>,
                                            ];
                                        }
                                    )}
                                </span>
                            </div>
                        )}

                        {product.comment && (
                            <div className="m2g-order-confirmation-product-comment m2g-text--offset m2g-text--small">
                                {_.escape(product.comment)}
                            </div>
                        )}
                    </td>

                    <td className="m2g-order-confirmation-item-total m2g-order-confirmation-product-total">
                        {t('common:price', { price: product.list_total })}
                    </td>
                </tr>

                {sub_products.map(sub_product =>
                    this.renderSubProduct(sub_product, sub_product.cid)
                )}
            </>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(OrderProduct);
